<template>
    <v-app v-cloak>
        <!-- No Side Bar For Home Page -->
        <home-nav-bar/>
        <main>
            <v-container
                transition="slide-x-transition"
                fluid
                pa-0
                ma-0>
                <slot/>
            </v-container>
        </main>
    </v-app>
</template>

<script>
    import HomeNavBar from "../partials/HomeNavBar";

    export default {
        components: {
            HomeNavBar
        }
    };
</script>
